import React, {createContext, useContext, useEffect, useRef, useState} from 'react';
import {useHistory} from "react-router-dom";
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    Switch,
    Typography,
    useToastProvider
} from "@deere/fuel-react";
import SendIcon from "@material-ui/icons/Send";
import {Dropdown} from "@deere/ux.uxframe-react";
import {getTotalPoints, getPointsForSubCategory, getTotalWeight, sortFilterRatingCriteria} from '../shared/utils';
import {useAuthConfig} from "../shared/helper";
import {useOktaAuth} from '@okta/okta-react';
import {
    CURRENT_RATINGS,
    CURRENT_RATINGS_DUE,
    MID_YEAR,
    NOT_AE_SUPPLIER,
    NOT_IN_AE_SUPPLIER,
    NOT_IN_AE_SUPPLIER_PLURAL,
    PAST_PERFORMANCE_OVERVIEW,
    SUPPLIER_NOT_CONSISTENT,
    SUPPLIER_STATE,
    YEAR_END
} from "../shared/Constants";
import {Loading} from "../shared/Loading";
import {Controller, useForm} from "react-hook-form";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {useStyles} from "../shared/styles/Ratings";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {NoData} from "../shared/NoData";
import clsx from 'clsx';
import {RatingCriteriaList} from "./RatingCriteriaList";
import {RatingsOverallSummaryCard} from "./RatingsOverallSummaryCard";
import {RatingsCategoryCard} from "./RatingsCategoryCard";
import {RatingsCategoryComments} from "./RatingsCategoryComments";
import {RatingsSummary} from './RatingsSummary';
import Collapse from "@material-ui/core/Collapse";
import {UserContext} from "./Main";
import {SupplierNumberAndUnits} from "../shared/filter/SupplierNumberAndUnits";
import {RatingsPastPerformanceOverviewCard} from './RatingsPastPerformanceOverviewCard';

export const CampaignContext = createContext();
export const UnitsContext = createContext();
export const RolesContext = createContext();
export const ReasonsContext = createContext();
export const Ratings = ({name}) => {
    const classes = useStyles();
    const {authState} = useOktaAuth();

    const initRatingPeriodCurrentPeriod = {
        "id": 0,
        "period": 0,
        "fiscalYear": "current"
    };

    // const initRatingPeriod = {
    //     "id": 10,
    //     "period": 2,
    //     "fiscalYear": "2025"
    // }

    const userInfo = useContext(UserContext);
    const {enqueueToast} = useToastProvider();
    let authAxios = useAuthConfig();
    const {control} = useForm();
    const [state, setState] = useState(SUPPLIER_STATE);
    const [isLoading, setIsLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [categoriesList, setCategoriesList] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState({});
    const [isWarning, setIsWarning] = useState(false);
    const [isNotValid, setIsNotValid] = useState(false);
    const [isOverallOverrideEdit, setIsOverallOverrideEdit] = useState(false);
    const [warningMsg, setWarningMsg] = useState("");
    const [categoryId, setCategoryId] = useState(0);
    const [categoryName, setCategoryName] = useState("Summary");
    const [selectedCategoryId, setSelectedCategoryId] = useState(0);
    const [summaryExpanded, setSummaryExpanded] = useState(false);
    const [summaryCampaigns, setSummaryCampaigns] = useState({});
    const [subCategories, setSubCategories] = React.useState([]);
    const [isSupplierAdmin, setIsSupplierAdmin] = useState(false);
    const [isActionsAllowed, setIsActionsAllowed] = useState(false)
    const [isSupplierMimic, setIsSupplierMimic] = useState(false)
    const [totalPoints, setTotalPoints] = useState("");
    const [totalWeight, setTotalWeight] = useState("");
    const [projectedPoints, setProjectedPoints] = useState(0);
    const [summaryTotal, setSummaryTotal] = useState(0);
    const [pointsList, setPointsList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [reasonsList, setReasonsList] = useState([]);
    const [ratingsPeriod, setRatingsPeriod] = useState([]);
    const [ratingClassifications, setRatingClassifications] = useState([]);
    const [ratingsPerfSummary, setRatingsPerfSummary] = useState([]);
    const [ratingSpendData, setRatingSpendData] = useState([]);
    const [totalOverrideObj, setTotalOverrideObj] = useState(null);
    const [selectedRatingPeriod, setSelectedRatingPeriod] = useState(initRatingPeriodCurrentPeriod);
    const userId = userInfo && userInfo.userId;
    const suppliersList = userInfo && userInfo.suppliersList;
    const [selectedSuppliers, setSelectedSuppliers] = useState([]);
    const [selectedSupplierObj, setSelectedSupplierObj] = useState({});
    const [selectedSupplierNumbers, setSelectedSupplierNumbers] = useState([]);
    const [supplierNumbers, setSupplierNumbers] = useState([]);
    const [selectedUnits, setSelectedUnits] = useState([]);
    const [units, setUnits] = useState([]);
    const [pastPerformanceRating, setPastPerformanceRating] = useState([]);
    const [ratingTeam, setRatingTeam] = useState([]);
    const [pastPerformanceOverview, setPastPerformanceOverview] = useState([]);
    const [userAssociatedSuppliers, setUserAssociatedSuppliers] = useState([]);
    const hasFetchedUserAssociatedSuppliers = useRef(false);

    const noDataMessage = {
        textLine1: "No Criteria available for this SubCategory"
    }

    const handleExpandClick = () => {
        setSummaryExpanded(!summaryExpanded);
    };


    const navigate = useHistory();

    const handleNavigation = () => navigate.push({
        pathname: "/campaigns/create-campaign",
        state: {
            supplierNo: selectedSupplier,
            supplierName: state.supplierName
        }
    });

    const transformTeamMemberAssociationToSupplierList = (data) => {
        const supplierNumbersSet = new Set(data.map(item => item.supplierNumber.trim()));
        return {supplierNumbers: Array.from(supplierNumbersSet)};
    }

    useEffect(() => {
        if (userId && !hasFetchedUserAssociatedSuppliers.current && userInfo && !userInfo.isSupplier) {
            hasFetchedUserAssociatedSuppliers.current = true;
            getUserAssociatedSuppliers(userId).then(res => {
                if (res && res.data && res.data.length > 0) {
                    const supplierNumbers = transformTeamMemberAssociationToSupplierList(res.data);
                    getSupplierOptions(supplierNumbers).then(r => {
                        if (r && r.data) {
                            setOptions(r.data);
                            setUserAssociatedSuppliers(r.data);
                        }
                    });
                }
            }).catch(console.error);
        }
        // eslint-disable-next-line
    }, [userId]);


    const getSupplierOptions = async (values) => {
        try {
            return await authAxios.post(`/suppliers`, values);
        } catch (e) {
            console.error(e);
        }
    }

    const getUserAssociatedSuppliers = async (userId) => {
        try {
            return await authAxios.post(`/teamLeader/search`, {"memberIds": [userId]});
        } catch (e) {
            console.error(e);
        }
    }

    const getRatingTeam = async (suppNum) => {
        try {
            return await authAxios.get(`/teams/${suppNum}`);
        } catch (e) {
            console.error(e)
        }
    }

    const getTeamLead = () => {
        if (ratingTeam === undefined || ratingTeam?.length === 0) {
            return "";
        }
        const teamLeader = ratingTeam?.teamMembers?.filter((member) => member?.teamLeader === "Y")
        if (!teamLeader?.length) {
            return ""
        }
        return teamLeader[0]?.racfId?.toUpperCase();
    }

    const getSupplierRatingsDetails = async (supplierNumber, period, fiscalYear) => {
        try {
            const data = {
                supplierNumber: supplierNumber,
                period: period,
                fiscalYear: fiscalYear
            };
            return await authAxios.post(`/rating`, data);
        } catch (e) {
            const res = e.response
            if (res && res.status === 500)
                enqueueToast({
                    variant: "error",
                    title: "Error fetching Supplier details",
                    message: e.response ? e.response.data[e.response.status.toString()] : "",
                    isPersistent: true
                });
            else {
                setIsNotValid(true)
                setWarningMsg(e.response ? e.response.data[e.response.status.toString()] : "Error fetching Supplier details")
            }
            setIsLoading(false)
        }
    };

    const getCampaignDetails = async (supplierNumber, period, fiscalYear) => {
        try {
            const data = {
                supplierNumber: supplierNumber,
                period: period,
                fiscalYear: fiscalYear
            }
            return await authAxios.post(`/ratingCampaigns`, data);
        } catch (e) {
            // This happens intermittently,
            // and I have not yet been able to identify the root cause
            // It is likely related to Okta session or token expiry
            // So, just reload the app once per day if this happens (once per day to avoid reload loops)
            {
                const localStorageKey = "lastCampaignErrorTimestamp";
                const lastCampaignErrorTimestamp = localStorage.getItem(localStorageKey);

                const oneDay = 24 * 60 * 60 * 1000;
                const now = Date.now();

                if (lastCampaignErrorTimestamp == null || (now - lastCampaignErrorTimestamp) > oneDay) {
                    localStorage.setItem(localStorageKey, now);
                    
                    // remove okta stuff and reload
                    localStorage.removeItem("okta-token-storage");
                    localStorage.removeItem("okta-cache-storage");
                    window.location.reload();
                    return;
                }

            }

            enqueueToast({
                variant: "error",
                title: "Error fetching SBM details",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    };

    const getPastPerformanceSummary = async (supplierNumber, period, fiscalYear) => {
        try {
            const data = {
                supplierNumber: supplierNumber,
                period: period,
                fiscalYear: fiscalYear
            }
            return await authAxios.post(`/pastPerformanceSummary`, data);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching past performance summary details",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    };

    const saveOverrideScore = async (dataObj) => {
        try {
            const data = {
                supplierNumber: selectedSupplier,
                period: selectedRatingPeriod.period,
                fiscalYear: selectedRatingPeriod.fiscalYear,
                comments: dataObj.comment,
                reasonId: parseFloat(dataObj.reason),
                overridePoints: parseFloat(dataObj.score),
            }
            return await authAxios.post(`/total-override-save`, data);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error saving override values",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    };

    const deleteOverrideScore = async () => {
        try {
            const data = {
                supplierNumber: selectedSupplier,
                period: selectedRatingPeriod.period,
                fiscalYear: selectedRatingPeriod.fiscalYear
            }
            return await authAxios.post(`/total-override-delete`, data);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error deleting override values",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    };

    const getOverrideScore = async (supplierNumber, period, fiscalYear) => {
        try {
            const data = {
                supplierNumber: supplierNumber,
                period: period,
                fiscalYear: fiscalYear
            }
            return await authAxios.post(`/total-override`, data);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching override values",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    };

    const getRatingSpendData = async (supplierNumber, period, fiscalYear) => {
        try {
            const data = {
                supplierNumber: supplierNumber,
                period: period,
                fiscalYear: fiscalYear
            }
            return await authAxios.post(`/ratingSpendData`, data);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching ratingSpendData details",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    };

    const getCategories = async () => {
        try {
            return await authAxios.get(`/categories`);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching categories",
                isCloseable: false
            });
        }
    };

    const getRatingPeriods = async () => {
        try {
            return await authAxios.get(`/ratingPeriods`);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching rating periods",
                isCloseable: false
            });
        }
    };

    const getRatingClassifications = async () => {
        try {
            return await authAxios.get(`/ratingClassifications`);
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching rating classifications",
                isCloseable: false
            });
        }
    };

    const getSuppliersList = async (value) => {
        setSearchLoading(true)
        try {
            await authAxios.get(`/suppliers?queryString=${value}`).then(res => {
                const newOptions = [...res.data, ...userAssociatedSuppliers];
                const uniqueOptions = Array.from(new Set(newOptions.map(item => item.supplierNumber)))
                    .map(supplierNumber => newOptions.find(item => item.supplierNumber === supplierNumber));
                setOptions(uniqueOptions)
                setSearchLoading(false)
            })
        } catch (e) {
            console.error(e);
            setSearchLoading(false)
        }
    };

    const getSupplierPastPerformanceOverview = async (supplierNumber) => {
        try {
            return await authAxios.post('/legacyRatings', {
                supplierNumber: supplierNumber
            });
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching legacy rating details",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    }

    const getUniqueSubCategories = (criteriaObj, id) => {
        const currentTabCriteria = criteriaObj && criteriaObj.filter(criteriaItem => criteriaItem.category["id"] === id)
        return [...new Map(currentTabCriteria && currentTabCriteria.map((item) => [item["subCategory"]["id"], item["subCategory"]])).values()];
    }

    const processSupplierData = (data, updateType = "") => {
        if (!data.isSupplierConsistent) {
            setIsNotValid(true)
            setWarningMsg(SUPPLIER_NOT_CONSISTENT)
        } else if (!data.suppliers) {
            setIsNotValid(false)
            setIsWarning(true)
            if (suppliersList && suppliersList.length > 1)
                setWarningMsg(NOT_IN_AE_SUPPLIER_PLURAL)
            else
                setWarningMsg(NOT_IN_AE_SUPPLIER)
            setState(SUPPLIER_STATE);
        } else if (data.suppliers[0].supplierInd === "N") {
            setIsNotValid(false)
            setIsWarning(true)
            setWarningMsg(NOT_AE_SUPPLIER)
            setState(SUPPLIER_STATE);
        } else {
            if (updateType !== "period") {
                setCategoryName("Summary");
                setCategoryId(0);
                setSelectedCategoryId(0);
                setSubCategories([]);
            }
            setState({
                ...state,
                isSupplierConsistent: data.isSupplierConsistent,
                isSupplierGroup: data.isSupplierGroup,
                parentName: data.parentName,
                suppliers: data.suppliers,
                functionalArea: data.functionalArea,
                subFunctionalAreaId: data.subFunctionalAreaId,
                supplierInd: data.suppliers[0].supplierInd,
                supplierName: data.suppliers[0].supplierName,
                criteria: data.criteria,
                generalComments: data.generalComments,
                categoryComments: data.categoryComments
            });

            setIsWarning(false)
            setIsNotValid(false)
            setWarningMsg("")

            //Default Quality Category Total
            const totalPoints = getTotalPoints(data.criteria, 1)
            const totalWeight = getTotalWeight(data.criteria, 1)
            setTotalPoints(totalPoints);
            setTotalWeight(totalWeight);
            if (totalPoints !== 0 && totalWeight !== 0)
                setProjectedPoints(Math.round((totalPoints / totalWeight) * 100))

            //Summary Total
            const pointsArr = categoriesList.filter(item => item.id !== 0).map((item) => {
                const categoryTotalPoints = getTotalPoints(data.criteria, item.id);
                const categoryTotalWeight = getTotalWeight(data.criteria, item.id);
                const categoryProjectedPoints = (categoryTotalPoints !== 0 && categoryTotalWeight !== 0) ? Math.round((categoryTotalPoints / categoryTotalWeight) * 100) : 0;
                return {
                    id: item.id,
                    points: categoryTotalWeight === 100 ? categoryTotalPoints : categoryProjectedPoints
                }
            })
            setPointsList(pointsArr)
            setSummaryTotal(pointsArr.map(item => item.points).reduce((prev, curr) => prev + curr, 0))
        }
        setSummaryExpanded(true)

        let pushSupplierNumbers = [];
        pushSupplierNumbers.push(...(data.suppliers && data.suppliers.map(item => ({
            id: item.supplierNumber,
            description: item.supplierName + " - " + item.supplierNumber.replace(/^0+/, ''),
            checked: true
        }))));
        setSupplierNumbers(pushSupplierNumbers)
        setSelectedSupplierNumbers(pushSupplierNumbers)

        let filteredUnits;
        filteredUnits = data?.criteria && data.criteria.map(item => {
            if (item.feedbacks.length > 0) {
                return item.feedbacks.map(feedback => feedback.stakeholder.unitId)
            }
            return undefined
        })

        filteredUnits = (filteredUnits.filter(item => item !== undefined)).flat(2);

        const supplierUnits = unitList.filter(item => filteredUnits.includes(item.id))
        supplierUnits.forEach((item) => {
            item['checked'] = true
        })
        setUnits(supplierUnits)
        setSelectedUnits(supplierUnits)

        setIsLoading(false)
    };

    const processSbmData = (data, period) => {
        setSummaryCampaigns(data)
        const allSuppliersSBM = [];
        allSuppliersSBM.push(...(data.suppliers && data.suppliers.map(item => (item.sbm && item.sbm.userId && item.sbm.userId.toUpperCase())).filter(Boolean)));
        allSuppliersSBM.push(...(data.suppliers && data.suppliers.map(item => (item.sro && item.sro.userId && item.sro.userId.toUpperCase())).filter(Boolean)));
        allSuppliersSBM.push(...(data.suppliers && data.suppliers.map(item => (item.gro && item.gro.userId && item.gro.userId.toUpperCase())).filter(Boolean)));

        const currentDate = new Date().setHours(0, 0, 0, 0);

        //Actions are allowed only for Admin, suppliers SBM, SRO or GRO and only in current Ratings option before current ratings due date
        const isAdmin = ((allSuppliersSBM && allSuppliersSBM.includes(userId?.toUpperCase())) || userInfo.isCriteriaAdmin) && (new Date(data.currentDueDate) >= currentDate);
        setIsSupplierAdmin(isAdmin);
        setIsActionsAllowed(isAdmin && period === 0);
    };

    const handleSelectedCategory = (id, name) => {
        setCategoryId(id);
        setCategoryName(name)
        setSelectedCategoryId(id);
        setSubCategories(id !== 0 ? getUniqueSubCategories(state.criteria, id).sort((a, b) => a.id - b.id) : [])
        const totalPoints = getTotalPoints(state.criteria, id);
        const totalWeight = getTotalWeight(state.criteria, id);
        setTotalPoints(totalPoints);
        setTotalWeight(totalWeight);
        if (totalPoints !== 0 && totalWeight !== 0)
            setProjectedPoints(Math.round((totalPoints / totalWeight) * 100));
    }

    const handleSupplierObjectChange = (value) => {
        setSelectedSupplierObj(value)
        handleValueChange(value.supplierNumber)
    }

    const handleSupplierNumberChange = (event) => {
        const updatedSupplierNumbers = supplierNumbers.map(supplierNumberObj => {
            if (supplierNumberObj.id === event.target.name) {
                supplierNumberObj.checked = event.target.checked
                if (event.target.checked) {
                    setSelectedSupplierNumbers([...selectedSupplierNumbers, {
                        id: event.target.name,
                        description: event.target.description
                    }])
                } else {
                    setSelectedSupplierNumbers(selectedSupplierNumbers.filter((supplierNumber) => supplierNumber.id !== event.target.name))
                }
            }
            return supplierNumberObj
        })
        setSupplierNumbers(updatedSupplierNumbers)
    }

    const handleUnitsChange = (event) => {
        const updatedUnits = units.map(unitObj => {
            if (unitObj.id === event.target.name) {
                unitObj.checked = event.target.checked
                if (event.target.checked) {
                    setSelectedUnits([...selectedUnits, {id: event.target.name, description: event.target.description}])
                } else {
                    setSelectedUnits(selectedUnits.filter((supplierNumber) => supplierNumber.id !== event.target.name))
                }
            }
            return unitObj
        })
        setUnits(updatedUnits)
    }

    const handleReset = () => {
        supplierNumbers.forEach((item) => {
            item['checked'] = true
        })
        setSelectedSupplierNumbers(supplierNumbers)

        units.forEach((item) => {
            item['checked'] = true
        })
        setSelectedUnits(units)
    }

    const handleSupplierView = (e) => {
        setIsSupplierMimic(e.target.checked)
    }

    const handleOverrideScore = (data, type) => {
        type === "save" && saveOverrideScore(data).then(res => {
            if (res && res.data.id) {
                setIsOverallOverrideEdit(true)
                setTotalOverrideObj(res.data)
                getPastPerformanceSummary(selectedSupplier, selectedRatingPeriod.period, selectedRatingPeriod.fiscalYear).then(response => {
                    setRatingsPerfSummary(response.data)
                })
            }
        }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error saving override details",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        });

        type === "delete" && deleteOverrideScore().then(res => {
            if (res && res.data.id) {
                setIsOverallOverrideEdit(false)
                setTotalOverrideObj(null)
                getPastPerformanceSummary(selectedSupplier, selectedRatingPeriod.period, selectedRatingPeriod.fiscalYear).then(response => {
                    setRatingsPerfSummary(response.data)
                })
            }
        }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error deleting override details",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        });
    }

    const handleValueChange = (value) => {
        setCategoryId(0);
        setSelectedSupplier(value);
        setState(SUPPLIER_STATE);
        if (value && selectedRatingPeriod && selectedRatingPeriod.fiscalYear === 'Past Performance Overview') {
            setIsLoading(true);
            getSupplierPastPerformanceOverview(value)
                .then((response) => setPastPerformanceOverview(response.data))
                .then(() => setIsLoading(false))
                .catch((err) => {
                    console.error(err);
                })
        } else if (value && Object.keys(value).length > 0 && Object.keys(selectedRatingPeriod).length > 0) {
            setIsLoading(true);

            // Get supplier details
            getSupplierRatingsDetails(value, selectedRatingPeriod.period, selectedRatingPeriod.fiscalYear).then(res => {
                res && processSupplierData(res.data, "supplier")
            });

            // Get campaign details
            getCampaignDetails(value, selectedRatingPeriod.period, selectedRatingPeriod.fiscalYear).then(response => {
                response && processSbmData(response.data, selectedRatingPeriod.period)
            });

            // Get past performance summary
            getPastPerformanceSummary(value, selectedRatingPeriod.period, selectedRatingPeriod.fiscalYear).then(response => {
                setRatingsPerfSummary(response.data)
                setIsOverallOverrideEdit(response.data.filter(item => item.isCurrent)[0].totalUpdatedScore !== null)
            });

            // Get rating spend data
            getRatingSpendData(value, selectedRatingPeriod.period, selectedRatingPeriod.fiscalYear).then(response => {
                setRatingSpendData(response.data)
            });

            // Get override score if not current period
            selectedRatingPeriod.period !== 0 && getOverrideScore(value, selectedRatingPeriod.period, selectedRatingPeriod.fiscalYear).then(response => {
                setTotalOverrideObj(response.data)
            });

            // Get rating team
            getRatingTeam(value).then((response) => {
                setRatingTeam(response?.data)
            });

            setPastPerformanceOverview([]);
        }
    }

    const handleRatingsPeriod = (ratingPeriod) => {
        setSelectedRatingPeriod(ratingPeriod)
        setState(SUPPLIER_STATE);
        if (ratingPeriod && ratingPeriod.fiscalYear === 'Past Performance Overview') {
            setIsLoading(true);
            getSupplierPastPerformanceOverview(selectedSupplier)
                .then((response) => setPastPerformanceOverview(response.data))
                .then(() => setIsLoading(false))
                .catch((err) => {
                    console.error(err);
                })
        } else if (ratingPeriod && Object.keys(ratingPeriod).length > 0 && Object.keys(selectedSupplier).length > 0) {
            setIsLoading(true);

            // Get supplier details for new period
            getSupplierRatingsDetails(selectedSupplier, ratingPeriod.period, ratingPeriod.fiscalYear).then(res => {
                res && processSupplierData(res.data, "period")
            });

            // Get campaign details for new period
            getCampaignDetails(selectedSupplier, ratingPeriod.period, ratingPeriod.fiscalYear).then(response => {
                response && processSbmData(response.data, ratingPeriod.period)
            });

            // Get past performance summary for new period
            getPastPerformanceSummary(selectedSupplier, ratingPeriod.period, ratingPeriod.fiscalYear).then(response => {
                setRatingsPerfSummary(response.data)
                setIsOverallOverrideEdit(response.data.filter(item => item.isCurrent)[0].totalUpdatedScore !== null)
            });

            // Get rating spend data for new period
            getRatingSpendData(selectedSupplier, ratingPeriod.period, ratingPeriod.fiscalYear).then(response => {
                setRatingSpendData(response.data)
            });

            // Get override score for new period if not current
            ratingPeriod.period !== 0 && getOverrideScore(selectedSupplier, ratingPeriod.period, ratingPeriod.fiscalYear).then(response => {
                setTotalOverrideObj(response.data)
            });

            setPastPerformanceOverview([]);
        }
    }

    const handlePastPerformanceOverview = () => {
        handleRatingsPeriod({
            id: null,
            period: null,
            fiscalYear: PAST_PERFORMANCE_OVERVIEW
        })
    }

    const processTabData = data => {
        const summaryObj = {"id": 0, "description": "Summary", "subCategories": []}
        data.splice(0, 0, summaryObj)
    };

    const getSelectedRatings = () => {
        const {
            id,
            period,
            fiscalYear
        } = selectedRatingPeriod;

        if (id === 0) {
            return CURRENT_RATINGS;
        } else {
            if (!id && !period) {
                return PAST_PERFORMANCE_OVERVIEW;
            }
            return `${period === 1 ? MID_YEAR : YEAR_END} ${fiscalYear}`;
        }
    }

    const getRoles = async () => {
        try {
            return await authAxios.get(`/stakeholders?functionalAreaCodes=All`);
        } catch (e) {
            console.error(e);
        }
    };

    const getUnits = async () => {
        try {
            return await authAxios.get(`/units`);
        } catch (e) {
            console.error(e);
        }
    };

    const getReasons = async () => {
        try {
            return await authAxios.get(`/ratingReasons`);
        } catch (e) {
            console.error(e);
        }
    };

    const handleStateData = (type, data) => {
        const updatedRows = state.criteria.map((row) => {
            if (type === "override") {
                if (data.overridePoints !== null) {
                    if (row.id === data.criteriaId) {
                        row.overridePoints = data.overridePoints
                        row.overrideReason = {
                            id: data.id,
                            reasonId: data.reasonId,
                            comments: data.comments,
                            updatedBy: data.updatedBy
                        }
                    }
                }
            }
            if (type === "override-delete") {
                if (row.id === data.criteriaId) {
                    row.overrideReason = null
                }
            }
            if (type === "notApplicable") {
                if (data.reasonId) {
                    if (row.id === data.criteriaId) {
                        row.notApplicableReason = {
                            id: data.id,
                            reasonId: data.reasonId,
                            comments: data.comments,
                            updatedBy: data.updatedBy
                        }
                    }
                }
            }
            if (type === "notApplicable-delete") {
                if (row.id === data.criteriaId) {
                    row.notApplicableReason = null
                }
            }
            if (row.id === data.criteriaId) {
                row.feedbacks.map((feedbacks) => {
                    if (feedbacks.feedback.feedbackId === data.feedbackId) {
                        feedbacks.feedback.isCommentVisible = data.visibilityInd;
                    }
                    return feedbacks;
                })
            }
            return row;
        });
        setState({
            ...state,
            criteria: updatedRows
        });
        const totalPoints = getTotalPoints(updatedRows, categoryId);
        const totalWeight = getTotalWeight(updatedRows, categoryId);
        setTotalPoints(totalPoints);
        setTotalWeight(totalWeight);
        if (totalPoints !== 0 && totalWeight !== 0)
            setProjectedPoints(Math.round((totalPoints / totalWeight) * 100));

        //Summary Total
        const pointsArr = categoriesList.filter(item => item.id !== 0).map((item) => {
            const categoryTotalPoints = getTotalPoints(updatedRows, item.id);
            const categoryTotalWeight = getTotalWeight(updatedRows, item.id);
            const categoryProjectedPoints = (categoryTotalPoints !== 0 && categoryTotalWeight !== 0) ? Math.round((categoryTotalPoints / categoryTotalWeight) * 100) : 0;
            return {
                id: item.id,
                points: categoryTotalWeight === 100 ? categoryTotalPoints : categoryProjectedPoints
            }
        })
        setPointsList(pointsArr)
        setSummaryTotal(pointsArr.map(item => item.points).reduce((prev, curr) => prev + curr, 0))
    }

    // Update the state after single category comment state update
    const handleCategoryStateData = (type, data) => {
        if (type === "categoryComment-save") {
            const updatedRowsAdd = state.categoryComments;
            let categoryCommentAdd = {
                id: data.id,
                categoryId: data.categoryId,
                comment: data.comment,
                user: data.user,
                submittedDate: data.submittedDate,
                isCommentVisible: data.isCommentVisible,
                role: data.role
            }
            updatedRowsAdd.push(categoryCommentAdd)
            setState({
                ...state,
                categoryComments: updatedRowsAdd
            });
        }
        if (type === "generalComment-visibility") {
            const updatedRows = state.generalComments?.map((row) => {
                row.comments = row.comments.map((comment) => {
                    if (comment.feedbackId === data.feedbackId && parseInt(comment.categoryId) === parseInt(data.categoryId)) {
                        comment.isCommentVisible = data.visibilityInd;
                    }
                    return comment;
                })
                return row
            })
            setState({
                ...state,
                generalComments: updatedRows
            });
        }
        const updatedRows = state.categoryComments?.map((row) => {
            if (type === "categoryComment-update") {
                if (row.id === data.id && row.categoryId === data.categoryId)
                    return {
                        id: data.id,
                        categoryId: data.categoryId,
                        comment: data.comment,
                        user: data.user,
                        submittedDate: data.submittedDate,
                        isCommentVisible: data.isCommentVisible,
                        role: data.role
                    }
            }
            if (type === "categoryComment-updateVisibility") {
                if (row.id === data.id && row.categoryId === data.categoryId)
                    return {
                        id: data.id,
                        categoryId: data.categoryId,
                        comment: row.comment,
                        user: row.user,
                        submittedDate: row.submittedDate,
                        isCommentVisible: data.isCommentVisible,
                        role: row.role
                    }
            }
            if (type === "categoryComment-delete") {
                if (row.id === data.categoryCommentId)
                    return {}
            }
            return row;
        });
        setState({
            ...state,
            categoryComments: updatedRows
        });
    }

    useEffect(() => {
        setSelectedSuppliers(suppliersList)
        if (suppliersList && suppliersList.length > 0)
            handleSupplierObjectChange(suppliersList[0])

        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [suppliersList, categoriesList]);

    useEffect(() => {
        getRoles().then(res => {
            setRoleList(res.data);
        });
        getUnits().then(res => {
            setUnitList(res.data);
        });
        getReasons().then(res => {
            setReasonsList(res.data);
        });

        getCategories().then(res => {
            setCategoriesList(res.data);
            processTabData(res.data)
        }).catch((error) => {
            console.log(error)
        });

        getRatingPeriods().then(res => {
            //to filter out period before 2022 since it will be viewed in Legacy application
            const periodAfter2022 = res.data.filter(item => item.fiscalYear > 2022)

            const tempArr = [initRatingPeriodCurrentPeriod, ...periodAfter2022]
            setRatingsPeriod(tempArr);
            const pastPerformanceRatingPeriod = res.data.slice(0, 5).filter(item => item.period === 2)
            setPastPerformanceRating(pastPerformanceRatingPeriod);
        }).catch((error) => {
            console.log(error)
        });

        getRatingClassifications().then(res => {
            setRatingClassifications(res.data);
        }).catch((error) => {
            console.log(error)
        });

        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <Grid container>
            <Grid item xs={12} className="sticky-header">
                <Typography variant="h1" component="h1">
                    {state.suppliers.length > 0 ? (state.isSupplierGroup ? `${name} for: Supplier Group - ${state.parentName.toUpperCase()}` : `${name} for: ${state.supplierName.toUpperCase()} - ${parseInt(state.suppliers[0].supplierNumber)}`) : `${name} for`}
                </Typography>
                <Typography variant="h4">
                    {state.suppliers.length > 0 ? `Rated as ${state.functionalArea["description"]} - ${state.functionalArea["subFunctionalArea"].filter(ele => ele.id === state.subFunctionalAreaId)[0]["description"]}` : 'Rated as'}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Box m={2}>
                    <Card style={{overflow: "visible"}}>
                        <CardContent>
                            <Grid container>
                                <Grid item xs={9}>
                                    <Box display="flex" justifyContent="flex-start">
                                        <Box display="inline-flex">
                                            <IconButton
                                                className={
                                                    clsx(classes.expand, {
                                                        [classes.expandOpen]: summaryExpanded,
                                                    })}

                                                onClick={handleExpandClick}
                                                aria-expanded={summaryExpanded}
                                                aria-label="show more"
                                            >
                                                <ExpandMoreIcon/>
                                            </IconButton>
                                        </Box>
                                        <FormControl style={{width: 500}} component="fieldset">
                                            {(userInfo && userInfo.isSupplier) ?
                                                <Autocomplete
                                                    size="small"
                                                    id={"suppliersList"}
                                                    options={selectedSuppliers}
                                                    value={selectedSupplierObj}
                                                    getOptionLabel={(option) => `${option.supplierName} - ${parseInt(option.supplierNumber)}`}
                                                    getOptionSelected={(option, value) => option.supplierNumber === value.supplierNumber}
                                                    onChange={(e, value) => {
                                                        value && handleSupplierObjectChange(value)
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} variant="outlined"/>
                                                    )}
                                                />
                                                :
                                                <Controller
                                                    control={control}
                                                    name="supplier"
                                                    defaultValue={selectedSupplier}
                                                    value={selectedSupplier}
                                                    render={({onChange, value}) => (
                                                        <Autocomplete
                                                            size="small"
                                                            id="supplierSearch"
                                                            options={options}
                                                            getOptionLabel={(option) => `${option.supplierName} - ${parseInt(option.supplierNumber)}`}
                                                            getOptionSelected={(option, value) => option.supplierNumber === value.supplierNumber}
                                                            loading={searchLoading}
                                                            onChange={(e, value) => {
                                                                handleValueChange(value && value.supplierNumber)
                                                                onChange(value)
                                                            }}
                                                            onInputChange={(e, value) => {
                                                                if (value.length > 2)
                                                                    getSuppliersList(value)
                                                            }}
                                                            renderInput={(params) =>
                                                                <TextField {...params}
                                                                           placeholder="Search Supplier name or number (enter 3 or  characters)"
                                                                           variant="outlined"/>}
                                                        />
                                                    )}
                                                />
                                            }
                                        </FormControl>
                                        <Box display="flex" alignContent="center" ml={4} mt={2}>
                                            <Dropdown>
                                                <Dropdown.Toggle variant="" id="ratings-dropdown"
                                                                 style={{padding: 0, color: "#367c2b"}}>
                                                    {getSelectedRatings()}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {ratingsPeriod.length > 0 && ratingsPeriod.map((item) => {
                                                        const ratingPeriodDisplay = item.id === 0
                                                            ? CURRENT_RATINGS
                                                            : `${item.period === 1 ? MID_YEAR : YEAR_END} ${item.fiscalYear}`;

                                                        return <React.Fragment key={item.id}>
                                                            <Dropdown.Item
                                                                onClick={() => handleRatingsPeriod(item)}>
                                                                {ratingPeriodDisplay}
                                                            </Dropdown.Item>
                                                        </React.Fragment>;
                                                    })}
                                                    <Dropdown.Item onClick={handlePastPerformanceOverview}>
                                                        {PAST_PERFORMANCE_OVERVIEW}
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs={3}>
                                    {state.suppliers.length > 0 && selectedRatingPeriod.id === 0 && (
                                        <Box display="flex" justifyContent="flex-end" alignContent="center" mt={2}>
                                            <Typography
                                                display="inline" variant="label">{CURRENT_RATINGS_DUE}:
                                            </Typography>
                                            <Typography
                                                display="inline" variant="body2">
                                                &nbsp;{`${summaryCampaigns.currentDueDate}`}</Typography>
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container>
                                {isNotValid ? (
                                    <Grid item xs={12}>
                                        <Box m={4}>
                                            <Alert
                                                variant={"error"}>{warningMsg}</Alert>
                                        </Box>
                                    </Grid>
                                ) : (
                                    <>
                                        {isWarning ? (
                                            <Grid item xs={12}>
                                                <Box m={4}>
                                                    <Alert
                                                        variant={"warning"}>{warningMsg}</Alert>
                                                </Box>
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12}>
                                                {state.suppliers.length > 0 &&
                                                    <Collapse in={summaryExpanded} timeout="auto" unmountOnExit>
                                                        <Grid container alignItems="flex-end">
                                                            <Grid item xs={9}>
                                                                <RatingsOverallSummaryCard
                                                                    expanded={summaryExpanded}
                                                                    classifications={ratingClassifications}
                                                                    ratingsPerfSummary={ratingsPerfSummary}
                                                                    summaryTotal={summaryTotal}
                                                                    reasons={reasonsList}
                                                                    ratingPeriod={selectedRatingPeriod.period}
                                                                    isEdit={isOverallOverrideEdit}
                                                                    totalOverrideObj={totalOverrideObj}
                                                                    onOverrideSave={handleOverrideScore}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                {!isSupplierMimic && (userInfo.isCriteriaAdmin || userId === getTeamLead()) &&
                                                                    <Box display="flex" justifyContent="flex-end"
                                                                         mb="1.2rem">
                                                                        <Button
                                                                            variant="text"
                                                                            startIcon={<SendIcon/>}
                                                                            onClick={handleNavigation}>
                                                                            Launch Campaign
                                                                        </Button>
                                                                    </Box>
                                                                }
                                                                {userInfo && !userInfo.isSupplier &&
                                                                    <Box display="flex" justifyContent="flex-end">
                                                                        <FormControlLabel
                                                                            control={<Switch
                                                                                name="supplier view"
                                                                                onChange={handleSupplierView}

                                                                            />}
                                                                            label="Supplier View"
                                                                            style={{marginRight: "0"}}
                                                                        />
                                                                    </Box>
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Collapse>
                                                }
                                            </Grid>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    {isLoading && (
                        <Grid item xs={12}>
                            <Loading/>
                        </Grid>
                    )}
                    {!isLoading && state.suppliers.length > 0 && !isNotValid && selectedRatingPeriod.id !== null && (
                        <>
                            <Grid item xs={12} md={3}>
                                <Box m={2} style={{position: "sticky", top: 80}}>
                                    <RatingsCategoryCard
                                        categoriesList={categoriesList}
                                        categoryId={categoryId}
                                        selectedCategoryId={selectedCategoryId}
                                        subCategories={subCategories}
                                        onCategoryChange={handleSelectedCategory}
                                        criteria={state.criteria}
                                        summaryTotal={summaryTotal}
                                        pointsList={pointsList}/>
                                    {supplierNumbers.length > 0 && categoryId !== 0 && (
                                        <Box style={{marginTop: "10px"}}>
                                            <SupplierNumberAndUnits
                                                expanded={true}
                                                title="Supplier Number"
                                                data={supplierNumbers}
                                                handleChange={handleSupplierNumberChange}
                                            />
                                            <SupplierNumberAndUnits
                                                expanded={true}
                                                title="Units"
                                                data={units}
                                                handleChange={handleUnitsChange}
                                            />
                                            <Box className="fixed-bottom position-sticky view-result">
                                                <Button variant="primary" fullWidth={true} size="large"
                                                        onClick={handleReset}>Reset</Button>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <>
                                    {state.suppliers.length > 0 && (
                                        <Grid container>
                                            {categoryId === 0 && (
                                                <CampaignContext.Provider value={summaryCampaigns}>
                                                    <RatingsSummary
                                                        isSupplier={(userInfo && userInfo.isSupplier) || isSupplierMimic}
                                                        pastPerformanceRating={pastPerformanceRating}
                                                        supplierNumber={selectedSupplier}
                                                        fiscalYear={selectedRatingPeriod.fiscalYear}
                                                        spendData={ratingSpendData}
                                                        functionalArea={state.functionalArea["description"]}
                                                        onPastPerformanceOverview={handlePastPerformanceOverview}
                                                    />
                                                </CampaignContext.Provider>
                                            )}
                                            {categoryId !== 0 && (
                                                <>
                                                    <Grid item xs={8}>
                                                        <Box ml={4} mr={4} mt={4}>
                                                            <Typography variant="h3" component="h3">
                                                                {categoryName}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Box display="flex" justifyContent="flex-end" ml={4} mr={4}
                                                             mt={4}>
                                                            <Typography variant="h3">
                                                                Total: {totalPoints}/{totalWeight} {parseInt(totalWeight) !== 100 && projectedPoints !== 0 && `(${projectedPoints}pts)`}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Box ml={4} mr={4}>
                                                            <UnitsContext.Provider value={unitList}>
                                                                <RolesContext.Provider value={roleList}>
                                                                    <RatingsCategoryComments
                                                                        categoryId={categoryId}
                                                                        isActionsAllowed={isActionsAllowed}
                                                                        isSupplierMimic={isSupplierMimic}
                                                                        generalComments={state.generalComments}
                                                                        suppliers={state.suppliers}
                                                                        ratingPeriod={selectedRatingPeriod}
                                                                        userInfo={userInfo}
                                                                        categoryComments={state.categoryComments}
                                                                        updateVisibilityState={handleCategoryStateData}/>
                                                                </RolesContext.Provider>
                                                            </UnitsContext.Provider>
                                                        </Box>
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid item xs={12}>
                                                <Box ml={4} mr={4}>
                                                    {subCategories.length > 0 && subCategories.map((subCategory, index) => {
                                                        const points = getPointsForSubCategory(state.criteria, subCategory.id);
                                                        const subCategoryTotal = points.score;
                                                        const subCategoryWeight = points.maxPointsAvailable;

                                                        return (
                                                            <React.Fragment key={subCategory.id}>
                                                                <Grid container id={`#${categoryId}-${subCategory.id}`}>
                                                                    <Grid item xs={12}>
                                                                        <Grid container>
                                                                            <Grid item xs={9}>
                                                                                <Box display="flex" mr={4}
                                                                                     mt={4}>
                                                                                    <Typography variant="h3"
                                                                                                component="h3">
                                                                                        {subCategory.description}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Box display="flex"
                                                                                     justifyContent="flex-end" ml={4}
                                                                                     mr={2} mt={4}>
                                                                                    <Typography variant="h3">
                                                                                        Total: {subCategoryTotal}/{subCategoryWeight}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                {state.criteria && state.criteria.length > 0 && sortFilterRatingCriteria(state, subCategory.id, selectedUnits, selectedSupplierNumbers).length > 0 ? sortFilterRatingCriteria(state, subCategory.id, selectedUnits, selectedSupplierNumbers).map((criteria, index) => {
                                                                    return (
                                                                        <UnitsContext.Provider value={unitList} key={criteria.id}>
                                                                            <RolesContext.Provider value={roleList}>
                                                                                <ReasonsContext.Provider
                                                                                    value={reasonsList}>
                                                                                    <RatingCriteriaList
                                                                                        functionalAreaId={state.functionalArea["id"]}
                                                                                        criteria={criteria}
                                                                                        key={selectedSuppliers || selectedUnits}
                                                                                        isActionsAllowed={isActionsAllowed}
                                                                                        isSupplierAdmin={isSupplierAdmin}
                                                                                        suppliers={state.suppliers}
                                                                                        userInfo={userInfo}
                                                                                        isSupplierMimic={isSupplierMimic}
                                                                                        ratingPeriod={selectedRatingPeriod}
                                                                                        updateVisibilityState={handleStateData}
                                                                                    />
                                                                                </ReasonsContext.Provider>
                                                                            </RolesContext.Provider>
                                                                        </UnitsContext.Provider>
                                                                    )
                                                                }) : (
                                                                    <NoData noDataMessage={noDataMessage}/>
                                                                )}
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}
                                </>
                            </Grid>
                        </>
                    )}
                    {!isLoading && selectedRatingPeriod.id === null && pastPerformanceOverview?.length > 0 && (
                        <RatingsPastPerformanceOverviewCard pastPerformance={pastPerformanceOverview}/>)}
                </Grid>
            </Grid>
        </Grid>
    );
}
